import type { StepContentConfig } from '@workspace/core-ts/utils';

const recapGptContent: StepContentConfig = {
    mainTitle: {
        site: 'Vérifiez vos informations',
    },
    mainDescription: {
        site: 'Voici les informations collectées par ChatGPT. Vérifiez-les avant de continuer.',
    },
    mainDescriptionAgent: {
        site: "Voici les informations collectées par l'agent conversationnel. Vérifiez-les avant de continuer.",
    },
    vehiculeTitle: {
        site: 'Mon vélo',
    },
    consentLabel: {
        site: "Je confirme que les informations ci-dessus, collectées lors de ma conversation avec l'assistant ChatGPT, sont exactes et j'autorise leur utilisation pour l'établissement de mon devis d'assurance.",
    },
    consentLabelAgent: {
        site: "Je confirme que les informations ci-dessus, collectées lors de ma conversation avec l'agent conversationnel, sont exactes et j'autorise leur utilisation pour l'établissement de mon devis d'assurance.",
    },
};

export default recapGptContent;
